import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Typography } from '@mui/material';

/**
 * Seletor de range de tempo: 24h / 7d / 30d.
 * Componente controlado — pai mantém o state e passa onChange.
 */
export default function RangePicker({ value, onChange }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                Período
            </Typography>
            <ToggleButtonGroup
                value={value}
                exclusive
                size="small"
                onChange={(_, v) => v && onChange(v)}
                color="primary"
            >
                <ToggleButton value="24h">Últimas 24h</ToggleButton>
                <ToggleButton value="7d">7 dias</ToggleButton>
                <ToggleButton value="30d">30 dias</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
